var _classCallCheck = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/steven/Documents/code/others/fourth_year_project/constellations/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var CurrencyConversionError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(CurrencyConversionError, _Error);

  /**
   *
   * @param {string} message
   */
  function CurrencyConversionError(message) {
    var _this;

    _classCallCheck(this, CurrencyConversionError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurrencyConversionError).call(this, message));
    _this.name = 'CurrencyConversionError';
    _this.message = message;
    return _this;
  }

  return CurrencyConversionError;
}(_wrapNativeSuper(Error));
/**
 *
 * @param {number|string} value
 * @param {'satoshi'|'mbtc'|'btc'} convertFrom
 * @returns {number|string}
 * @throws {CurrencyConversionError}
 */


function convertCurrencyToSatoshi(value, convertFrom) {
  switch (convertFrom.toUpperCase()) {
    case 'SATOSHI':
      return value;

    case 'MBTC':
      return value * 100000;

    case 'BTC':
      return value * 100000000;

    default:
      throw new CurrencyConversionError("Unsupported conversion origin format: ".concat(convertFrom, "."));
  }
}
/**
 *
 * @param {number|string} value
 * @param {'satoshi'|'mbtc'|'btc'} convertTo
 * @param {'satoshi'|'mbtc'|'btc'} convertFrom
 * @returns {number|string}
 * @throws {CurrencyConversionError}
 */


function convertCurrencyTo(value, convertTo) {
  var convertFrom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'satoshi';
  var pvalue = convertCurrencyToSatoshi(value, convertFrom);

  switch (convertTo.toUpperCase()) {
    case 'SATOSHI':
      return pvalue;

    case 'MBTC':
      return (pvalue / 100000).toFixed(5);

    case 'BTC':
      return (pvalue / 100000000).toFixed(8);

    default:
      throw new CurrencyConversionError("Unsupported conversion destination format: ".concat(convertTo, "."));
  }
}

module.exports = {
  convertCurrencyTo: convertCurrencyTo,
  CurrencyConversionError: CurrencyConversionError,
  convertCurrencyToSatoshi: convertCurrencyToSatoshi
};